var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check 1",
    clipPath: "url(#clip0_997_66227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110.231 109.746C134.391 85.5856 134.391 46.4144 110.231 22.2544C86.071 -1.90567 46.8998 -1.90567 22.7398 22.2544C-1.42028 46.4144 -1.42028 85.5856 22.7398 109.746C46.8998 133.906 86.071 133.906 110.231 109.746Z",
    fill: "#41EAD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9882 77.5808L92.0888 43.4802C92.5648 42.9894 93.1337 42.5982 93.7624 42.3294C94.391 42.0605 95.0669 41.9194 95.7506 41.9142C96.4343 41.909 97.1122 42.0398 97.7449 42.2991C98.3776 42.5583 98.9524 42.9408 99.4358 43.4243C99.9193 43.9078 100.302 44.4826 100.561 45.1152C100.82 45.7479 100.951 46.4258 100.946 47.1095C100.941 47.7932 100.8 48.4691 100.531 49.0977C100.262 49.7264 99.8707 50.2953 99.38 50.7714L61.6336 88.5174C60.6667 89.4841 59.3554 90.0271 57.9882 90.0271C56.6209 90.0271 55.3096 89.4841 54.3427 88.5174L33.6202 67.7952C32.6775 66.8234 32.1549 65.5198 32.1652 64.1659C32.1755 62.812 32.7179 61.5165 33.6753 60.5591C34.6326 59.6017 35.9282 59.0593 37.2821 59.049C38.636 59.0387 39.9396 59.5613 40.9114 60.504L57.9882 77.5808Z",
    fill: "#F8FEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_66227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.54ccc472597775de26c98187970d9b2e.svg";
export { ForwardRef as ReactComponent };